// removed by extract-text-webpack-plugin
module.exports = {"root":"_1smweOCaIWaM0zlKPidLrn","muhimma":"_20Iy-On_L2tWDuWuBa8_Xj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/h2.scss
// module id = 1190
// module chunks = 0